import {Pipe, PipeTransform} from '@angular/core';

/**
 * Форматирует значение объекта стажа вида {years: 1, months: 1} в человекочитаемую строку вида "1 год и 1 месяц стаж"
 * {years: 0, months: 0} -> Без стажа
 * {years: 21, months: 0} -> 21 год стаж
 * {years: 0, months: 4} -> 4 месяца стаж
 * {years: 3, months: 5} -> 3 года и 5 месяцев стаж
 */

@Pipe({name: 'serviceFormatter'})
export class ServiceFormatterPipe implements PipeTransform {
    transform(service): any {
        let yearsTitle = '';
        let monthTitle = '';

        if (service.years) {
            switch (+service.years % 10) {
                case 1 : {
                    yearsTitle = 'год';
                    break;
                }

                case 2:
                case 3:
                case 4: {
                    yearsTitle = 'года';
                    break;
                }

                default : {
                    yearsTitle = 'лет';
                }
            }

            yearsTitle = service.years + ' ' + yearsTitle;
        }
        if (service.months) {
            switch (service.months) {
                case 1 : {
                    monthTitle = 'месяц';
                    break;
                }

                case 2:
                case 3:
                case 4: {
                    monthTitle = 'месяца';
                    break;
                }

                default : {
                    monthTitle = 'месяцев';
                }
            }
            monthTitle = service.months + ' ' + monthTitle;
        }

        let message = '';

        if (!service.years && !service.months) {
            message = 'Без стажа';
        } else if (service.years && !service.months) {
            message = yearsTitle;
        } else if (!service.years && service.months) {
            message = monthTitle;
        } else {
            message = yearsTitle + ' и ' + monthTitle;
        }

        return message;
    }
}

